import router from "@/router";
export const goToPage = function (urlName: string): void {
  router.push({
    name: urlName,
  });
};
